<template>
  <el-dialog :visible.sync="currentValue" width="1477px" top="auto" custom-class="task-dialog" :show-close="false" :before-close="dialogBeforeClose">
    <template slot="title">
      <div class="task-head">
        <div class="task-head-left">
          <div class="task-head-in" :class="{'only-one': index === breadcrumb.length - 1}" v-for="(item,index) in breadcrumb" :key="item.id">
            <span class="task-head-space" v-if="index > 0">/</span>
            <toolTip v-if="item.type" class="task-head-txt" show title="进入项目主页" maxWidth="220px" @click.native="openedTask(item,index)">
              <span>{{item.task_name}}</span>
            </toolTip>
            <toolTip v-else class="task-head-txt" :title="item.task_name" maxWidth="220px" @click.native="openedTask(item,index)">
              <span>{{item.task_name}}</span>
            </toolTip>
          </div>
        </div>
        <div class="task-head-right">
          <!-- <div class="archive-btn-wrap" v-if="editData.archive_permission && editData.edit_permission && !editData.isDisabledProject" @click="archivedTask">
            <i class="icon iconfont iconicon_move"></i>
            <span>归档任务</span>
          </div> -->
          <template v-if="getFileCount > 0">
            <SelectFile v-if="getFileCount > 1" @change="uploadSuccess" />
            <el-tooltip v-else class="item" effect="dark" content="添加任务附件" placement="bottom">
              <SelectFile @change="uploadSuccess" />
            </el-tooltip>
          </template>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="添加子任务" placement="bottom" @click.native="addChild" v-if="!editData.pid">
            <i class="icon iconfont iconicon_subtasks2"></i>
          </el-tooltip>
          <el-tooltip  class="item" effect="dark" content="添加关联任务" placement="bottom" @click.stop.native="addConnect">
            <i class="icon iconfont iconicon_associated_tasks"></i>
          </el-tooltip>
          <el-dropdown @command="handleCommand" size="small" trigger="click" class="task-box-more" placement="bottom" :show-timeout="100">
            <i class="icon iconfont iconicon_more_task1"></i>
            <el-dropdown-menu slot="dropdown" class="task-box-more-dropdown">
              <el-dropdown-item command="del" class="task-box-more-del">
                <i class="icon iconfont iconicon_recycle_bin"></i>
                删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip class="item" effect="dark" content="关闭" placement="bottom">
            <i class="icon iconfont iconicon_close1" @click="currentValue = false"></i>
          </el-tooltip>
        </div>
      </div>
      <div class="tip-gre">项目模版部分功能不可用</div>
    </template>
    <div class="task-panel" v-loading="viewLoading">
      <div class="task-panel-wrap">
        <div class="task-panel-left" v-if="!viewLoading">
          <TaskTitle
            :editData="editData"
            :taskName.sync="form.task_name"
            :taskStatus.sync="form.task_stage"
            :isCompete="editData.before_archiving_is_completed"
            @change="saveData"
          ></TaskTitle>
          <FormTemp title="优先级" icon="iconicon_priority">
            <LevelStatus :readonly="false" v-model="form.sort_rule_id" :sortList="sortList" @change="saveData"/>
          </FormTemp>
          <FormTemp title="执行人" icon="iconicon_executor">
            <Executor :readonly="false" v-model="outerTaskExecutor_user" :defaultValue="editData.executor_user" :projectId="editData.project_id" :parentId="parentId" :user_in_parent_tasks_permission="editData.user_in_parent_tasks_permission" :isTemplate="true" @change="saveData"></Executor>
          </FormTemp>
          <FormTemp title="参与人" icon="iconicon_participant">
            <Participant
              v-if="!loading"
              :readonly="false"
              ref="ParticipantTemp"
              v-model="outerTask_members"
              :defaultValue="editData.task_members_user"
              :projectId="editData.project_id"
              :parentId="parentId"
              :taskId="taskId"
              @change="saveData"
              :isTemplate="true"
            ></Participant>
          </FormTemp>
          <FormTemp title="完成日期" icon="iconicon_time1">
            <RangeTime :readonly="false" :taskStatus="editData.task_stage" v-model="timeRange" @change="saveData" />
          </FormTemp>
          <template v-if="dataset.task_template_content">
            <FormTemp v-for="(item) in dataset.task_template_content.template_standard_components" :key="item.component_code + item.component_name_in_template" :readonly="false" :value="getTemplateDefaultValue(item)" :title="item.component_name_in_template" :icon="keyIcon[item.component_code] || 'iconicon_custom_field'" v-if="item.is_show">
              <component
                :readonly="false"
                :item="item"
                :is="item.component_code"
                v-model="form[`${getketText(item)}`]"
                :projectId="editData.project_id"
                :config="getTempConfig(item)"
                :memberList="memberList"
                :defaultValue="getTemplateDefaultValue(item)"
                :getketText="getketText"
                :isTaskDetail="true"
                @change="saveData"
                :isTemplate="true"
              ></component>
            </FormTemp>
          </template>
        </div>
        <div class="task-panel-right" ref="task-preview" v-if="!viewLoading">
          <ChildTask
            ref="chaildtask"
            :create_subtask_permission="true"
            @openedTask="opendAddTask"
            :taskId="editData.id"
            :projectId="editData.project_id"
            :taskListId="editData.task_list_id"
            :templateId="template_id"
            :parentExecutorUid="form.executor"
            :isDisabledProject="editData.isDisabledProject"
            :dataset="editData.children"
            @change="childTaskChange"
            v-if="!editData.pid"
          ></ChildTask>

          <ConnectTask
            ref="connect"
            :project_id="editData.project_id"
            :editData="editData"
            :primission="true"
            :addPrimission="true"
            :association_dependency="editData.association_dependency || {}"
            :isDisabledProject="editData.isDisabledProject"
            @change="connectChange"
            @openedTask="opendAddTask"
            @del="connectDel"
          ></ConnectTask>
<!--
          <Comment
            ref="comment"
            :taskId="editData.id"
            :project_id="editData.project_id"
            @toScorllTop="toScorllTop"
          ></Comment> -->
        </div>
      </div>

    </div>

  </el-dialog>
</template>

<script>
import api from '@/services/api/customKey/customKey';
import apiTask from '@/services/api/task/task';
import apiRecycle from '@/services/api/recycle';
import followApi from '@/services/api/follow/follow'
import apiMsg from '@/services/api/project/project';
import apiRecycleBin from '@/services/api/recycle';
import bus from '@/bus'
import TaskTitle from './taskTitle'
import FormTemp from './formTemp'
import ChildTask from './childTask'
import ConnectTask from './connectTask'
import SelectFile from './selectFile'
import Comment from './comment'
import { mapActions ,  mapState, mapMutations} from 'vuex'

export default {
  props: {
    value: Boolean,
    openData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TaskTitle,
    FormTemp,
    ChildTask,
    ConnectTask,
    Comment,
    SelectFile,
  },
  data() {
    return {
      form: {
        task_name: '',
        sort_rule_id: '',
        task_stage: '',
        executor: '',
        start_time: '',
        end_time: '',
        task_members: []
      },
      outerTaskExecutor_user: {},
      outerTask_members: [],
      breadcrumb: [],
      viewLoading: true,
      template_id: '',
      tableTemplate: [],
      sortList: [],
      memberList: [],
      timeRange: [],
      taskId: '',
      loading: false,
      isNeedReset: false,
      isWriting: false,
      isCheckClosed: false,
    }
  },
  watch: {
    timeRange() {
      if (this.timeRange && this.timeRange.length > 0) {
        this.form.start_time = this.timeRange[0]
        this.form.end_time = this.timeRange[1]
      } else {
        this.form.start_time = ''
        this.form.end_time = ''
      }
    },
    value(val) {
      if (val) {
        this.taskId = this.opendTaskId
      }
    },
  },
  computed: {
    ...mapState('template/template', {
      dataset: state => state.dataset
    }),
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        if (!newValue) {
          this.closed()
        }
        this.$emit('input', newValue || null)
      }
    },
    parentId() {
      let item = this.breadcrumb[this.breadcrumb.length - 2]
      return item && !item.type ? item.id : ''
    },
    getFileCount() {
      return this.dataset?.task_template_content?.template_standard_components.reduce((pre, item) => {
        if (item.component_code === 'TaskComponent.Attachment.Attachment' && item.is_show === 1) {
          return pre + 1
        } else {
          return pre
        }
      }, 0)
    }
  },
  created() {
    this.getFromRules(this.openData)
  },
  methods: {
    ...mapMutations('template/template', ['task_del', 'task_add', 'task_update_id']),
    ...mapActions('template/template', ['task_find_id']),
    async getFromRules(dataVal) {
      this.loading = true
      this.init()
      this.editData = JSON.parse(JSON.stringify(dataVal))
      await this.getTaskSortList() // 获取优先级
      await this.getTaskDetail() // 获取任务详情
      this.loading = false
    },
    async opendAddTask(item) {
      // 打开子任务保存当前任务
      let result = await this.task_find_id(item.id)
      let index = this.breadcrumb.findIndex(res => res.id === item.id)
      if(index > -1) {
        this.breadcrumb.splice(index + 1)
      } else {
        this.breadcrumb.push(result)
      }
      this.getFromRules(result)
    },
    async openedTask(item, index) {
      console.log(item, index)
      if(item.type) {
        this.$router.push(`templateProjectDetail?id=${item.id}`)
        this.currentValue = false
        return
      }
      if (item.id === this.taskId) return
      if (index > -1) {
        this.breadcrumb.splice(index + 1)
      }
      this.taskId = item.id
      this.getFromRules(await this.task_find_id(item.id))
    },
    opendNewTask(item) {
      this.taskId = item.id
      this.breadcrumb = []
    },
    init() {
      this.editData = {}
      this.timeRange = []
      this.tableTemplate = []
      this.isCheckClosed = false
      this.isWriting = false
      this.form = {
        task_name: '',
        sort_rule_id: '',
        task_stage: '',
        executor: '',
        start_time: '',
        end_time: '',
        task_members: []
      }
    },
    tileData(dataList) {
      let arr = [];
      dataList.forEach(item => {
        arr = [...arr, ...item.member];
      });
      return arr;
    },
    getTaskSortList() {
      return apiTask.getTaskSortList({ sort_rule_type_id: 1 }).then(res => {
        this.sortList = res.reverse()
      })
    },
    getTaskDetail() {
        this.viewLoading = true
        this.form.task_name = this.editData.task_name
        this.form.sort_rule_id =  this.sortList.find(res => res.sort_name === this.editData.sort_rule_name)?.id
        this.form.task_stage = this.editData.task_stage
        if (this.editData.start_time && this.editData.end_time) {
          this.form.start_time = this.editData.start_time
          this.form.end_time = this.editData.end_time
          this.timeRange = [this.editData.start_time, this.editData.end_time]
        }
        if(this.breadcrumb.length === 0) {
          this.breadcrumb.push({
            task_name: this.dataset?.template_name,
            id: this.dataset?.id,
            type: 'project'
          })
          this.breadcrumb.push(this.editData)
        }
        this.taskId = this.editData.id
        this.editData = JSON.parse(JSON.stringify(this.editData))
        this.$nextTick(() => {
          this.viewLoading = false
        })
    },
    async saveData() {
      this.task_update_id(this.getCompeteData())
    },
    getCompeteData() {
      this.isWriting = true
      let standard_components_values = []
      for (let key in this.form) {
        if (key.indexOf('TaskComponent') > -1 && (this.form[key] || this.form[key] === null || this.form[key] === 0 || this.form[key] === '')) {
          let arr = key.split('-id-')
          standard_components_values.push({
            component_code:arr?.[0],
            component_name_in_template: arr?.[1],
            component_value: this.form[key] === null || this.form[key].length === 0 ? '' : this.form[key],
          })
        }
      }
      let params = {
        sort_rule_name: this.sortList.find(res => res.id === this.form.sort_rule_id)?.sort_name,
        task_name: this.form.task_name || '',
        standard_components_values
      }

      if (this.form.start_time) {
        params.start_time = this.form.start_time
        params.end_time = this.form.end_time
      } else {
        params.start_time = ''
        params.end_time = ''
      }
      if (this.breadcrumb.length) {
        this.breadcrumb[this.breadcrumb.length - 1].task_name = params.task_name
      }
      this.isWriting = false
      if(this.isCheckClosed) {
        this.currentValue = false
      }
      return {...this.editData, ...params}
    },
    dialogBeforeClose(done) {
      if(!this.isWriting) {
        done()
      }
      this.isCheckClosed = true
    },
    // 删除任务
    deletedTask($event) {
      this.$emit('del', this.editData.id)
    },
    handleCommand(type) {
      if (type === 'del') {
        this.deletedTask()
      }
    },
    getTempConfig(item) {
      let params = {
        ...item.component_config_in_template,
        component_desc_in_template: item.component_desc_in_template,
        component_name_in_template: item.component_name_in_template,
        component_code: item.component_code
      }
      return params
    },
    getTemplateDefaultValue(item) {
      if(!item || !this.editData) return
      let key = item.component_code + item.component_name_in_template
      let temp = this.editData.standard_components_values
      let component = temp.find(res => res.component_code + res.component_name_in_template === key) || ''
      return component ? component.component_value : ''
    },
    getketText(item, filter) {
      let strKey = item.component_code
      let text = strKey + '-id-' + item.component_name_in_template
      if (filter && !item.component_config_in_template.is_require) {
        return ''
      }
      return text
    },
    closed() {
      this.breadcrumb = []
      // this.saveData()
    },
    addChild() {
      this.$refs.chaildtask.addNewTask()
    },
    addConnect() {
      this.$refs.connect.opendPopover()
    },
    uploadSuccess(res) {
      if (!this.form[res.form]) {
        this.form[res.form] = []
        this.form[res.form].push(res.data.attachment_sign)
      } else {
        this.form[res.form].push(res.data.attachment_sign)
      }
    },
    toScorllTop() {
      console.log(this.$refs.comment)
      let doms = this.$refs['task-preview']
      let ele = this.$refs.comment.$el
      doms.scrollTop = ele.offsetTop - 200
    },
    childTaskChange(item) {
      this.editData.children = JSON.parse(JSON.stringify(item))
      this.saveData()
    },
    connectChange(val) {
      let { post_tasks, pre_tasks } = val
      this.dataset.project_template_content.task_list.map(res => {
        res.tasks.map(temp => {
          if(post_tasks.indexOf(temp.id) > -1 ) {
            temp.association_dependency.pre_tasks.push(this.editData.id)
          }
          if(pre_tasks.indexOf(temp.id) > -1 ) {
            temp.association_dependency.post_tasks.push(this.editData.id)
          }
          if(temp.children && temp.children.length > 0) {
            temp.children.map(data => {
              if(post_tasks.indexOf(data.id) > -1 ) {
                data.association_dependency.pre_tasks.push(this.editData.id)
              }
              if(pre_tasks.indexOf(data.id) > -1 ) {
                data.association_dependency.post_tasks.push(this.editData.id)
              }
            })
          }
        })
      })
      // this.$set(this.editData, 'association_dependency', JSON.parse(JSON.stringify(val)))
      this.saveData()
    },
    connectDel(id, val) {
      // console.log('llllllllll', val)
      this.$set(this.editData, 'association_dependency', JSON.parse(JSON.stringify(val)))
      this.$nextTick(() => {
        this.dataset.project_template_content.task_list.map(res => {
          res.tasks.map(temp => {
            if(temp.id === id ) {
              let pre_tasks_id = temp.association_dependency.pre_tasks.indexOf(this.editData.id)
              let post_tasks_id = temp.association_dependency.post_tasks.indexOf(this.editData.id)
              pre_tasks_id > -1 ? temp.association_dependency.pre_tasks.splice(pre_tasks_id, 1) : ''
              post_tasks_id > -1 ? temp.association_dependency.post_tasks.splice(post_tasks_id, 1) : ''
            }
            if(temp.children && temp.children.length > 0) {
              temp.children.map(data => {
                if(data.id === id ) {
                  let pre_tasks_id = data.association_dependency.pre_tasks.indexOf(this.editData.id)
                  let post_tasks_id = data.association_dependency.post_tasks.indexOf(this.editData.id)
                  pre_tasks_id > -1 ? data.association_dependency.pre_tasks.splice(pre_tasks_id, 1) : ''
                  post_tasks_id > -1 ? data.association_dependency.post_tasks.splice(post_tasks_id, 1) : ''
                }
              })
            }
          })
        })
        this.saveData()
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-war {
  padding-top: 10px;
  p {
    display: flex;
    align-items: center;
  }
  .dot {
    display: block;
  }
}
.task-dialog {
  max-width: 1420px;
  min-width: 1000px;
  .more {
    margin-left: 16px;
    width: 28px;
    height: 28px;
    border-radius: 2px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1px;
    box-sizing: border-box;
    margin-top: 10px !important;
    &:hover {
      @include bgColorOpacity(.06);
    }
    &:active {
      @include bgColorOpacity(.12);
    }
  }
  .task-head-is-deleted {
    position: relative;
    p {
      text-align: center;
    }
    .iconicon_close1 {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      font-size: 15px;
      padding: 4px;
      border-radius: 4px;
      margin-left: 16px;
      &:hover {
        background-color: rgba(32, 32, 32, 0.08);
        color: #2682ff;
      }
    }
  }
  .tip-gre {
    background-color: #EDEDED;
    color: rgba(32, 32, 32, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    font-size: 14px;
  }
  .task-head {
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 32px;
    justify-content: space-between;
    .task-head-left {
      display: flex;
      font-size: 16px;
      align-items: center;
      justify-content: flex-start;
      width: 0;
      flex: 1;
      line-height: 24px;
      .task-head-in {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        @include fontColorOpacity(.6);
        &:hover .task-head-txt {
          color: #202020;
          cursor: pointer;
        }
        &:last-child {
          &:hover .task-head-txt {
          cursor: auto;
          @include fontColorOpacity(1);
        }
        }
      }
      .task-head-space {
        flex-shrink: 0;
        padding: 0 5px;
      }
      .only-one {
        @include fontColorOpacity(1);
        // &:hover .task-head-txt {
        //   @include fontColorOpacity(1);
        // }
      }
    }
    .task-head-right {
      display: flex;
      align-items: center;
      i {
        color: rgba(32, 32, 32, 0.8) !important;
        &.iconicon_following {
          color: #FFBE23 !important;
        }
      }
      .archive-btn-wrap {
        width: 102px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid rgba(32, 32, 32, .16);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 32px;
        // margin-right: 17px;
        cursor: pointer;
        &:hover {
          @include bgColorOpacity(.06);
        }
        &:active {
          @include bgColorOpacity(.12);
        }
        i {
          font-size: 14px;
          margin-right: 8px;
        }
      }
      .item,
      .task-box-more,
      .select-file {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        @include fontColorOpacity(.8);
        cursor: pointer;
        border-radius: 4px;
        margin-left: 14px;
        &:hover {
          @include bgColorOpacity(.06);
        }
        &:active {
          @include bgColorOpacity(.12);
        }
        i {
          @include fontColorOpacity(.8);
          &.iconicon_guanzhu {
            color: #FFBE23;
          }
        }
      }
      .select-file {
        // margin: 0 16px 0 16px;
        i {
          &:hover {
            background: none;
            @include fontColorOpacity(.8);
          }
          &:active {
            background: none;
            @include fontColorOpacity(.8);
          }
        }
      }
      // .task-box-more {
      //   margin: 0 16px;
      // }
      // .iconicon_associated_tasks {
      //   margin-left: 16px;
      // }
    }
  }
  .task-panel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .task-head-stage {
      width: 100%;
      height: 48px;
      @include bgColorOpacity(.08);
      p {
        text-align: center;
        line-height: 48px;
        @include fontColorOpacity(.8);
        .recovery {
          cursor: pointer;
          margin-left: 8px;
          color: #2682FF;
          text-decoration: underline;
        }
      }
    }
    .task-panel-wrap {
      display: flex;
      flex: 1;
      height: 0;
    }
    .task-panel-left {
      overflow-x: hidden;
      padding: 24px 32px;
      border-right: 1px solid rgba(231, 232, 237, 0.6);
      flex: 1;
      box-sizing: border-box;
    }
    .task-panel-right {
      overflow-x: hidden;
      padding: 0 32px;
      box-sizing: border-box;
      flex-shrink: 0;
      width: 654px;
      box-sizing: border-box;
    }
  }
  .el-dialog__body {
    padding: 0;
    height: calc(100% - 90px);
    color: initial;
  }
  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #ecedf1;
  }
  height: 80%;
  transform: translate(0, -50%);
  top: 50%;
}
.connect-dialog,
.task-dialog {
  .complete-time {
    padding: 0;
    @include fontColorOpacity(.8);
    border-radius: 2px;
    font-size: 14px;
  }
  .remind {
    border: 0 none;
    color: #ff8b23;
  }
  .expired {
    border: 0 none;
    color: #ff3939;
  }
  .complete {
    border: 0 none;
  }
}

.task-panel-right-more {
  .el-dropdown-menu__item {
    justify-content: flex-start;
  }
}

.task-box-more-dropdown {
  .task-box-more-del {
    margin-bottom: 8px;
    // color: #FF3939;
    // &:hover {
    //   color: #FF3939;
    //   background: rgba(255, 57, 57, .08);
    // }
    // &:active {
    //   color: #FF3939 !important;
    //   background: rgba(255, 57, 57, .16) !important;
    // }
    i {
      // color: #FF3939;
      margin-right: 10px;
    }
  }
}
</style>
